import React from 'react';

const Step2_WabaIdInput = ({
  wabaId,
  setWabaId,
  onSubmit,
  onBack,
  loading,
  error
}) => {
  return (
    <div className="text-center">
      <div className="mb-6">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Step 2: Enter Your WABA ID</h2>
        <p className="text-gray-600 mb-6">
          Please provide your WhatsApp Business Account (WABA) ID to continue with the setup.
        </p>
      </div>

      <div className="max-w-md mx-auto">
        <div className="mb-4">
          <label htmlFor="wabaId" className="block text-sm font-medium text-gray-700 mb-2">
            WABA ID
          </label>
          <input
            type="text"
            id="wabaId"
            value={wabaId}
            onChange={(e) => setWabaId(e.target.value)}
            placeholder="Enter your WABA ID"
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#075e54] focus:border-transparent"
            disabled={loading}
          />
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg">
            {error}
          </div>
        )}

        <div className="flex gap-3">
          <button
            onClick={onBack}
            className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
          >
            Back
          </button>
          <button
            onClick={onSubmit}
            disabled={loading || !wabaId.trim()}
            className={`flex-1 px-6 py-3 rounded-lg font-semibold text-white transition-colors ${
              loading || !wabaId.trim()
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-[#075e54] hover:bg-[#054d44]'
            }`}
          >
            {loading ? 'Loading...' : 'Continue'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step2_WabaIdInput;
